import { render, staticRenderFns } from "./userCenter_renovation.vue?vue&type=template&id=849f159e&scoped=true"
import script from "./userCenter_renovation.vue?vue&type=script&lang=js"
export * from "./userCenter_renovation.vue?vue&type=script&lang=js"
import style0 from "./userCenter_renovation.vue?vue&type=style&index=0&id=849f159e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849f159e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('849f159e')) {
      api.createRecord('849f159e', component.options)
    } else {
      api.reload('849f159e', component.options)
    }
    module.hot.accept("./userCenter_renovation.vue?vue&type=template&id=849f159e&scoped=true", function () {
      api.rerender('849f159e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/userCenter/userCenter_renovation.vue"
export default component.exports